import { observable, computedFrom, BindingEngine, bindable, bindingMode, autoinject } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';
import { UpdateInsuranceDialog } from "../dialogs/update-insurance-dialog";
import { SecurityService } from '../../services/security-service';


@autoinject()
export class InsuranceCard {

    static instanceCount: number=0;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) item;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) carrierId;
    @bindable open: Function;

    constructor(
        private dialogService: DialogService,
        private securityService: SecurityService
    ) {
        this.id = "InsuranceCard" + InsuranceCard.instanceCount++;
    }

    id: String;

}